import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
})
export class AppComponent {
  title = 'Diario de abordo!';

  protected active_analytics = environment.production;

  constructor(private router: Router) {
    if (this.active_analytics) {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          (<any>window).ga('create', 'UA-118598080-1', 'auto');
          (<any>window).ga('set', 'page', event.urlAfterRedirects);
          (<any>window).ga('send', 'pageview');
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts